import { QUERY_PROGRESS_PENDING, QUERY_PROGRESS_SUCCEED } from "core/consts";
import { QueryProgress } from "core/types";
import React from "react";
import { useTranslations } from "translations";
import RSButton from "./index";

export default function RSButtonSaveProgress({
  disabled,
  onSubmit,
  queryProgress,
  style,
}: {
  disabled?: boolean;
  onSubmit: AnyFunction;
  queryProgress: QueryProgress;
  style?: React.CSSProperties;
}) {
  const translations = useTranslations();

  switch (queryProgress) {
    case QUERY_PROGRESS_PENDING:
      return (
        <RSButton
          color="secondary"
          id="saving"
          loading="na"
          style={style}
          variant="contained"
          onClick={onSubmit}
        >
          <span style={{ width: "100%" }}>{translations.actions.saving}</span>
        </RSButton>
      );
    case QUERY_PROGRESS_SUCCEED:
      return (
        <RSButton
          color="secondary"
          id="saved"
          loading="na"
          style={style}
          variant="contained"
          onClick={onSubmit}
        >
          <span style={{ width: "100%" }}>{translations.actions.saved}</span>
        </RSButton>
      );
    default:
      return (
        <RSButton
          color="secondary"
          disabled={disabled}
          id="save"
          loading="na"
          style={style}
          variant="contained"
          onClick={onSubmit}
        >
          <span style={{ width: "100%" }}>{translations.actions.save}</span>
        </RSButton>
      );
  }
}
